import { type Promotion } from "nvent-web-admin/types/Promotion";

import Resource from "./Resource";
import { decamelizeKeys } from "~/nvent-web/utils/decamelizeKeys";

export default class PromotionsResource extends Resource {
  async getAll(countryCode?: string) {
    return this.http
      .get<{ data: Promotion[] }>("/promotions", {
        params: decamelizeKeys({
          countryCode,
        }),
      })
      .then(({ data }) => data);
  }
}
